import Circle from "../components/Circle";
import { FaArrowDown } from "react-icons/fa";

function StatusContent({
  title,
  description,
  vesselCount,
  percentage,
  color,
  strokeDashOffset,
}) {
  return (
    <div className="w-full h-full p-8">
      <div className="status-title w-full h-[10%] text-sm m-2">
        <h1>{title}</h1>
      </div>
      <div className="status-main-content flex justify-center items-center w-full h-[90%]">
        <div className=" w-[60%] h-full flex flex-col justify-around">
          <div>
            <h1 className="text-sm">
              {"Total " + description + " ships this month unpermitted"}
            </h1>
          </div>
          <div className=" flex">
            <h1 className=" text-xl mr-2">{vesselCount} Vessels</h1>
            <FaArrowDown
              className={" text-red-500 rounded-full text-2xl -rotate-45  mr-1"}
            />
            <div className={" bg-red-500 p-1 rounded-3xl"}>
              <h1>25%</h1>
            </div>
          </div>
          <div>
            <h1 className="underline text-sm">Details</h1>
          </div>
        </div>
        <div className=" w-[40%] h-full relative">
          <div className=" w-full h-full absolute top-0 left-0 text-2xl flex justify-center items-center">
            <h1>{percentage}%</h1>
          </div>
          <div className=" w-full h-full absolute top-0 left-0">
            <Circle
              strokeColor={color}
              strokeWidth={12}
              strokeDashoffset={strokeDashOffset}
            ></Circle>
          </div>
          <div className=" w-full h-full">
            <Circle></Circle>
          </div>
        </div>
      </div>
    </div>
  );
}

StatusContent.defaultProps = {
  title: "Title",
  description: "this is descriptions",
  vesselCount: 300,
  percentage: 10,
};

export default StatusContent;
